import React, { useState } from "react";
import { Grid, Stack, Typography, Avatar, Box, Divider } from "@mui/material";
//Icons
import { BsInfoCircleFill } from "react-icons/bs";
import { MdContactMail } from "react-icons/md";
//Srcs
import "./studentinfo.scss";
import CakeImage from "../../Assets/birthday-cake.png";
import GenderImage from "../../Assets/equality.png";
import moment from "moment";
import EmptyImage from "../../Assets/empty-image.png";

export default function GuardianInfo({ detailsData }) {
  // console.log("guardian detailsData: ", detailsData)
  return (
    <div className="student-info">
      <Box className="main-containner">
        <Grid item container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={3}>
            <Box className="profile-container">
              <Stack
                className="profile"
                direction="row"
                justifycontent="center"
                sx={{ marginBottom: "20px" }}
              >
                <img
                  className="avater-image"
                  style={{ borderRadius: "10px" }}
                  src={
                    detailsData?.profileImg === "" ||
                    detailsData?.profileImg === undefined ||
                    detailsData?.profileImg === null
                      ? EmptyImage
                      : detailsData?.profileImg?.slice(0, 5) === "https"
                      ? detailsData?.profileImg
                      : `${process.env.React_App_VIEW_URL}${detailsData?.profileImg}`
                  }
                />
              </Stack>
              <Typography className="name-container-khmer">
                {detailsData?.lastName + " " + detailsData?.firstName}
              </Typography>
              <Typography className="name-container">
                {detailsData?.englishName}
              </Typography>
              <Stack
                direction="row"
                justifyContent="center"
                sx={{ marginTop: "20px" }}
              >
                <Stack direction="row" spacing={4} sx={{ width: "70%" }}>
                  <Stack
                    direction="column"
                    spacing={1}
                    className="birthday-card"
                  >
                    <Stack direction="row" justifyContent="center">
                      <img
                        src={GenderImage}
                        alt="Gender"
                        className="cake-img"
                      />
                    </Stack>
                    <Typography className="cake-title">
                      {detailsData?.gender}
                    </Typography>
                  </Stack>
                  <Stack
                    direction="column"
                    spacing={1}
                    className="birthday-card"
                  >
                    <Stack direction="row" justifyContent="center">
                      <img src={CakeImage} alt="Gender" className="cake-img" />
                    </Stack>

                    <Typography className="cake-title">
                      {moment(detailsData?.dob).format("DD-MMM-YYYY")}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={8} xl={9}>
            <Box className="details-container">
              <Grid container spacing={3}>
                {/* =============================== Student details =========================== */}
                <Grid item xs={6}>
                  <Stack direction="row" spacing={1.5}>
                    <BsInfoCircleFill className="details-icon" />
                    <Typography className="details-title">Guardian</Typography>
                  </Stack>
                  <Divider />
                  <Stack
                    direction="column"
                    spacing={1.5}
                    sx={{ marginTop: "20px" }}
                  >
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Last name
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.guardian?.lastName}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        First name
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.guardian?.firstName}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        English name
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.guardian?.englishName}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Date of birth
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.guardian?.dob
                          ? moment(detailsData?.guardian?.dob).format(
                              "DD-MMM-YYYY"
                            )
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Age</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {moment().diff(
                          moment(detailsData?.guardian?.dob),
                          "years"
                        )
                          ? moment().diff(
                              moment(detailsData?.guardian?.dob),
                              "years"
                            )
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Gender</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.guardian?.gender}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Nationality
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.guardian?.nationality}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Place of birth
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.guardian?.village
                          ? detailsData?.guardian?.village + ", "
                          : ""}
                        {detailsData?.guardian?.commune
                          ? detailsData?.guardian?.commune + ", "
                          : " "}
                        {detailsData?.guardian?.district
                          ? detailsData?.guardian?.district + ", "
                          : " "}
                        {detailsData?.guardian?.province
                          ? detailsData?.guardian?.province
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Permanent address
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.guardian?.permanentVillage
                          ? detailsData?.guardian?.permanentVillage + ", "
                          : " "}
                        {detailsData?.guardian?.permanentCommune
                          ? detailsData?.guardian?.permanentCommune + ", "
                          : " "}
                        {detailsData?.guardian?.permanentDistrict
                          ? detailsData?.guardian?.permanentDistrict + ", "
                          : " "}
                        {detailsData?.guardian?.permanentProvince
                          ? detailsData?.guardian?.permanentProvince + ", "
                          : " "}
                        {detailsData?.guardian?.permanentCountry
                          ? detailsData?.guardian?.permanentCountry
                          : " "}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
                {/* =============================== Contact details =========================== */}
                <Grid item xs={6}>
                  <Stack direction="row" spacing={1.5}>
                    <MdContactMail className="details-icon" />
                    <Typography className="details-title">
                      Contact details
                    </Typography>
                  </Stack>
                  <Divider />
                  <Stack
                    direction="column"
                    spacing={1.5}
                    sx={{ marginTop: "20px" }}
                  >
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Email</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.guardian?.email
                          ? detailsData?.guardian?.email
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Tel</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.guardian?.tel
                          ? detailsData?.guardian?.tel
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Facebook</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.guardian?.social
                          ? detailsData?.guardian?.social
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Occupation
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.father?.occupation
                          ? detailsData?.father?.occupation
                          : " "}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
